<template>
  <div id="standard-modal" :class="{ show: name, 'd-block': name }" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="standard-modalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="standard-modalLabel"> Delete Confirmation</h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"  @click="$emit('closeModal')"></button>
        </div>
        <div class="modal-body">
          <h6> Are you sure you want to delete the record named {{ name }}?</h6>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"  @click="$emit('closeModal')">
            Cancel
          </button>
          <button type="button" class="btn btn-danger"  @click="confirmDelete">
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import { defineEmits, defineProps } from 'vue'
defineProps({
  name: {
    type: String,
    default: "",
  },
})
const emit = defineEmits(['delRecord', 'closeModal'])
const confirmDelete = () => {
  emit('delRecord')
  emit('closeModal')
}
</script>
<style>
#standard-modal{
  background-color: rgb(12 12 12 / 50%);
  z-index:9999;
}
</style>